export const BUILD_VERSION = '97445418caea21eb32dfac989be484910508e76d';
